<template lang="pug">  
  v-app(id="inspire")        
    v-main      
      v-row
        v-col(
          cols="6").left
          info
        v-col(
          cols="6")          
          router-view            
</template>

<script>
import Info from './components/Info'
  export default {
    components: {
      Info
    },
    created() {
      this.$i18n.locale = 'es';
    },
  }
</script>
<style lang="scss" scoped>
html {
  font-family: poppins;
  
}
.left {
  background-color: #2032B0;
  height: 100vh;
  color: white;
}
</style>